<script lang="ts" setup>
import {
    GlobalMessage,
    useGlobalMessagesStore,
} from "@/stores/globalMessagesStore";
import { computed, onUpdated } from "vue";
import { Toast } from "bootstrap";
const globalMessages = useGlobalMessagesStore();

const getClass = function (item: GlobalMessage) {
    switch (item.type) {
        case "error":
            return "text-bg-danger";
        case "warning":
            return "text-bg-warning";
        case "info":
            return "text-bg-info";
        case "success":
            return "text-bg-success";
    }
};
const messages = computed(() => {
    return globalMessages.messages;
    // return globalMessages.messages.filter((obj) => {
    //     return obj.show != true;
    // });
});
onUpdated(() => {
    const toastElList = document.querySelectorAll(".toast");

    toastElList.forEach((x, index) => {
        const toast = new Toast(x);
        toast.show();

        x.addEventListener("hidden.bs.toast", function () {
            globalMessages.deleteByIndex(index);
        });
    });
});
</script>

<template>
    <div class="toast-container position-fixed bottom-0 end-0 p-3">

        <div :class="`toast align-items-center border-0 ${getClass(item)}`"
            v-for="(item, index) in messages"
            :key="`message_${index}`"
            role="alert"
            aria-live="assertive"
            aria-atomic="true">
            <div class="d-flex">
                <div class="toast-body">
                    {{item.message}}
                </div>
                <button type="button"
                    class="btn-close btn-close-white me-2 m-auto"
                    data-bs-dismiss="toast"
                    aria-label="Close"></button>
            </div>
        </div>

    </div>
</template>
